import styled, { css } from 'styled-components';

import { rem, toRemString } from '../../utils';

export type PanelDirection = 'row' | 'column';
export type PanelStyle = 'float' | 'default';
export type PanelWidthVariant = 'fullWidth' | 'default';

export const StyledWrapper = styled.div<{
  direction: PanelDirection;
  variant: PanelStyle;
  widthVariant: PanelWidthVariant;
}>`
  display: flex;
  width: inherit;
  max-width: fit-content;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-direction: ${({ direction }) => direction ?? 'row'};
  background: ${({ theme }) => theme.Components.Panel.Background};
  pointer-events: all;

  ${({ widthVariant }) =>
    widthVariant === 'fullWidth' &&
    css`
      max-width: inherit;
    `}

  ${({ theme, variant }) =>
    variant === 'float'
      ? css`
          border-radius: ${rem(theme.Border.Radius.Medium)};
          box-shadow: ${toRemString([0, 6, 16, 0])} rgba(0, 0, 0, 0.08),
            ${toRemString([0, 3, 6, -4])} rgba(0, 0, 0, 0.12),
            ${toRemString([0, 9, 28, 8])} rgba(0, 0, 0, 0.05);
        `
      : css`
          border-radius: ${rem(theme.Border.Radius.Large)};
          box-shadow: ${toRemString([0, 1, 2, 0])} rgba(0, 0, 0, 0.03),
            ${toRemString([0, 1, 6, -1])} rgba(0, 0, 0, 0.02),
            ${toRemString([0, 2, 4, 0])} rgba(0, 0, 0, 0.02);
        `}
`;

export const StyledPanelContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;

export const StyledPanelDivider = styled.div`
  display: flex;
  width: ${({ theme }) => rem(theme.Border.Size.Small)};
  background: ${({ theme }) => theme.Color.Neutrals.Light};
`;
